var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"small":"","outlined":"","color":!_vm.$attrs.color ? 'secondary' : _vm.$attrs.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }